import { Alert, AlertTitle, AlertDescription } from '@predoc/cow';
import { getMethodConfig } from './constants';
import { cn } from '@/lib/utils';
import { Info, Check } from 'lucide-react';

interface RequestSelectionItemProps {
  method: string;
  onToggle?: (method: string) => void;
  selected?: boolean;
  disabled?: boolean;
  disabledReason?: string;
  showError?: boolean;
}

export const RequestSelectionItem = ({
  method,
  onToggle,
  selected = false,
  disabled = false,
  disabledReason,
  showError = false,
}: RequestSelectionItemProps) => {
  const config = getMethodConfig(method);

  if (!config) return null;

  const IconComponent = config.icon;

  return (
    <Alert
      className={cn(
        'shadow-alert-shadow relative mb-4 flex border-t-0 transition-colors',
        disabled
          ? 'bg-accent border-border-d4 cursor-default border-1 opacity-90 shadow-none'
          : 'cursor-pointer hover:bg-gray-50',
        selected ? 'border-2 border-black' : '',
        showError ? 'border-destructive rounded-md border-2' : '',
      )}
      aria-disabled={disabled}
      onClick={() => (disabled ? undefined : onToggle?.(method))}
    >
      {selected ? (
        <div className="absolute top-3 right-3 flex h-4 w-4 items-center justify-center bg-black">
          <Check className="h-3 w-3 text-white" strokeWidth={3} />
        </div>
      ) : null}
      <div className="flex items-start gap-4">
        <IconComponent className="text-success mt-1 h-8 w-8" />
        <div>
          <AlertTitle className="text-lg">{config.title}</AlertTitle>
          <AlertDescription className="text-muted-foreground">
            {config.description}
          </AlertDescription>
          {disabled && disabledReason ? (
            <Alert className="bg-accent border-border-d4 mt-2 border-1 p-2 opacity-90">
              <Info className="h-4 w-4" />
              <AlertDescription className="text-muted-foreground text-xs">
                {disabledReason}
              </AlertDescription>
            </Alert>
          ) : null}
        </div>
      </div>
    </Alert>
  );
};
